import React, { useState, useEffect, useMemo } from "react";
import { Box, Typography, CircularProgress } from '@mui/material';
import ReactDatePicker from "react-datepicker";
import SchedulerLab from '../scheduleLab/SchedulerLab';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';

import '../../css/table-sort.css';

const themeColor = '#a71e3b';

function LabConsolleSchedulePage(props) {
    const [labData, setLabData] = useState();
    const [labSchedule, setLabSchedule] = useState();
    const [isLoading, setIsLoading] = useState(1);
    const [startDate, setStartDate] = useState(new Date());
    const [labEvents, setLabEvents] = useState([]);
    const [isSubmitble, setIsSubmitble] = useState(false);

    const labColumnsAdmin = useMemo(
        () => [
            {
                accessorKey: "email",
                header: "email",
                size: 150
            },
            {
                accessorKey: "idLab",
                header: "Identificativo",
                size: 150
            },
            {
                accessorKey: "labName",
                header: "Nome Laboratorio",
                size: 150
            }
        ], []);

    const table = useMaterialReactTable({
        columns: labColumnsAdmin,
        data: labData || [],
        enableGlobalFilterModes: true,
        enablePagination: false,
        enableBottomToolbar: false,
        enableColumnPinning: true,
        enableRowNumbers: false,
        enableRowVirtualization: true,
    });

    useEffect(() => {
        var formBody = [];

        function addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        }

        var myStartDate = new Date(startDate.toDateString()).toISOString();
        var myEndDate = addDays(startDate, 15);
        myEndDate = new Date(myEndDate.toDateString()).toISOString();

        const payload = {
            startDate: myStartDate,
            endDate: myEndDate,
        };

        formBody.push("payload=" + JSON.stringify(payload));

        setTimeout(async () => {
            setIsLoading(1);
            var myUrl = process.env.REACT_APP_URL_GET_SCHEDULE_ALL_LAB;

            await fetch(myUrl, {
                credentials: 'include',
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            })
                .then((resp) => resp.json())
                .then((data) => {
                    const allSchedulerLab = [];
                    const allTeachers = [];

                    data.forEach(elem => {
                        elem.usageData.schedulerLab.forEach(s => {
                            var s2 = {
                                teacher: s.teacher,
                                start: s.start,
                                end: s.end,
                                idLab: elem.idLab,
                                labName: elem.labName,
                                destinationId: elem.baseImage.destination.id,
                            };
                            allSchedulerLab.push(s2);
                        });
                        elem.teachers.forEach(t => {
                            allTeachers.push(t);
                        });
                    });

                    var allUsageData = {
                        usageData: {
                            schedulerLab: allSchedulerLab,
                        },
                        teachers: allTeachers
                    };

                    setLabSchedule(allUsageData);
                    setLabData(data);
                })
                .catch((error) => {
                    console.log(error, "Errore!");
                });
            setIsLoading(0);
        });
    }, [startDate]);

    const searchForm = () => {
        if (!props.isAdmin) return null;

        return (
            <Box sx={{ width: '85%', mb: 3 }}>
                <Typography
                    variant="body2"
                    sx={{
                        fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                        fontWeight: 600,
                        mb: 1
                    }}
                >
                    Vista pianificazioni
                </Typography>
                <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1 }}>
                    Data inizio pianificazione
                </Typography>
                <ReactDatePicker
                    dateFormat="dd MMMM yyyy"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    popperPlacement="top-end"
                />
            </Box>
        );
    };

    const isLoadingPage = () => {
        if (!isLoading) return null;

        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                <CircularProgress size={100} sx={{ color: themeColor }} />
            </Box>
        );
    };

    const resultSchedule = () => {
        if (isSubmitble) {
            // placeholder
        }

        if (isLoading) return null;

        return (
            <>
                <MaterialReactTable table={table} />
                <SchedulerLab
                    email={props.apiAuthResponse}
                    baseImage={labSchedule}
                    labEvents={labEvents}
                    setLabEvents={setLabEvents}
                    defaultView={'day'}
                    defaultDate={startDate}
                    setIsSubmitble={setIsSubmitble}
                    isSubmitted={0}
                />
            </>
        );
    };

    if (!labData) return null;

    return (
        <>
            <Typography
                variant="h5"
                sx={{
                    fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                    fontWeight: 400,
                    color: themeColor,
                    mb: 1
                }}
            >
                Vista pianificazione Laboratori Virtuali
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
                Questa pagina offre una visione complessiva delle schedulazioni a partire dalla data indicata
            </Typography>

            {searchForm()}
            {isLoadingPage()}
            {resultSchedule()}
        </>
    );
}

export default LabConsolleSchedulePage;
